<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1300px"
      :show-save-button="!readonly"
      unit="销货单"
      :edit-title="!readonly"
      id-key="DocId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      :close-on-saved="true"
      @edit-opened="onEditOpened"
      @create-opened="onCreateOpened"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="6">
            <el-form-item label="单据编号" prop="DocNo">
              <el-input v-model="data.DocNo" placeholder="请输入单据编号" v-if="noEdit" :disabled="readonly"></el-input>
              <span v-else>{{ data.DocNo }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单据日期" prop="DocDate">
              <el-date-picker
                style="width: 100%"
                v-model="data.DocDate"
                :placeholder="readonly ? '' : '请选择日期'"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :editable="false"
                v-if="!readonly"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="客户名称" prop="CustomerId">
              <customer @restaurants="setSupplier" :monthly="true" :state="data.CustomerName" />
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="!readonly && OrderType">
            <el-form-item label="销售单号" prop="OrderNo">
              <div @click="addOrder">
                <el-input
                  v-model="data.OrderNo"
                  :placeholder="readonly ? '' : '请选择销售单号'"
                  :disabled="readonly"
                  readonly
                  @focus="addOrder"
                  style="width: 220px"
                ></el-input>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收款条件" prop="ReceiptConditionId">
              <el-select style="width: 100%" v-model="data.ReceiptConditionId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly">
                <el-option
                  v-for="item in recCon"
                  :key="item.ReceiptConditionId"
                  :label="item.ReceiptConditionName"
                  :value="item.ReceiptConditionId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="票据类型" prop="InvoiceType">
              <invoice-select v-model="data.InvoiceType" @change="invoiceChange" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="data.NeedInvoice">
            <el-form-item label="发票号码" prop="InvoiceNo">
              <el-input v-model="data.InvoiceNo" :placeholder="readonly ? '' : '请输入发票号码'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="data.NeedInvoice">
            <el-form-item label="发票金额" prop="InvoiceAmount">
              <el-input v-model="data.InvoiceAmount" :placeholder="readonly ? '' : '请输入发票金额'" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="交货方式">
              <el-select style="width: 100%" v-model="data.FreightMode" :placeholder="readonly ? '' : '请选择'" :disabled="readonly">
                <el-option label="异地配送" :value="0"></el-option>
                <el-option label="本地配送" :value="1"></el-option>
                <el-option label="自提" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="业务员" prop="ClerkName">
              <el-input
                v-model="data.ClerkName"
                :placeholder="readonly ? '' : '请选择业务员'"
                @focus="addEmp"
                readonly
                style="width: 100%"
                :disabled="readonly"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="仓库" prop="WarehouseId">
              <select-input placeholder="选择仓库" :label="data.WarehouseName" v-model="data.WarehouseId" @click="openWarehouse" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="收货人" prop="Person">
              <!-- <el-input
                type="text"
                v-model="data.Person"
                placeholder="收货人"
                :disabled="readonly"
              ></el-input> -->
              <el-autocomplete
                id="autocomplete"
                ref="autocomplete"
                v-model="data.Person"
                value-key="Person"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入内容"
                @select="handleSelect"
                style="flex: 1; margin-right: 5px"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="联系电话" prop="Phone">
              <el-input type="text" v-model="data.Phone" placeholder="联系电话" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="Remark">
              <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注" :disabled="readonly"></el-input>
            </el-form-item>
          </el-col>
          <dialog-list ref="dialogList" :info="data" :readonly="readonly" @getList="getList" />
        </el-row>
        <el-col :span="6">
          <el-form-item label="无税金额" prop="NoTaxAmount">
            <span>{{ $commonJs.toThousands(data.NoTaxAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="税额" prop="TaxAmount">
            <span>{{ $commonJs.toThousands(data.TaxAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="订单金额" prop="Amount">
            <span>{{ $commonJs.toThousands(data.Amount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="其他费用" prop="OtherAmount">
            <span>{{ $commonJs.toThousands(data.ActualFreight) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="收款金额" prop="ReceiptAmount">
            <span>{{ $commonJs.toThousands(data.ReceiptAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="剩余金额" prop="RemainAmount">
            <span>{{ $commonJs.toThousands(data.RemainAmount) }}</span>
          </el-form-item>
        </el-col>
        <el-row>
          <el-row>
            <el-col :span="24">
              <el-divider />
              <span style="margin-left: 16px; line-height: 50px">收款信息</span>
              <el-button type="primary" icon="el-icon-plus" circle @click="add" v-if="!readonly" style="float: right; margin: 10px 15px 10px 0"></el-button>
            </el-col>
          </el-row>
          <el-row v-for="(item, index) in recList" :key="index">
            <el-col :span="6">
              <el-form-item label="结算方式" prop="SettleId">
                <el-select v-model="item.SettleId" placeholder="请选择" clearable :disabled="readonly" @change="saChange(index)">
                  <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收款账号" prop="AccountId">
                <el-select v-model="item.AccountId" placeholder="请选择" clearable :disabled="readonly" @change="saChange(index)">
                  <el-option v-for="acc in accountList" :key="acc.AccountId" :label="acc.Bank + acc.AccountNumber" :value="acc.AccountId"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="收款金额" prop="ReceiptAmount">
                <el-input
                  v-model="item.ReceiptAmount"
                  type="number"
                  @blur="onBlur(item, 'ReceiptAmount')"
                  @focus="onFocus(item, 'ReceiptAmount')"
                  @input="recChange(index)"
                  :disabled="readonly"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="1">
              <el-link :underline="false" @click="del(index)" v-if="!readonly">
                <i class="el-icon-delete" style="margin-left: 30px; line-height: 30px; font-size: 18px"></i>
              </el-link>
            </el-col>
          </el-row>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="danger" @click="cancelExamine" v-if="data.Status == 2 && canExa">弃 审</el-button>
        <el-button type="success" @click="examine" v-else-if="data.Status != 4 && canExa">审 核</el-button>
        <el-button @click="close" v-if="readonly">关 闭</el-button>
      </template>
    </common-dialog>
    <!-- <sa-dialog ref="saDialog" in-dialog selectable @select="setSa" /> -->
    <order-dialog ref="orderDialog" in-dialog selectable @select="setOrder" />
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <unit-dialog ref="unitDialog" in-dialog selectable @select="setUnit" title="客户列表" :typeList="[1, 2]" />
    <warehouse-dialog ref="warehouseDialog" in-dialog selectable @select="setWarehouse" title="仓库列表" :typeList="[1, 2]" />
  </div>
</template>
<script>
import customer from '@/components/common/customer/customer'
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import dialogList from './dialogList' //"./dialogList2";
// import saDialog from "@/components/sales/business/salesorder/saListDialog";
import orderDialog from '@/components/mall/worder/allSaOrder/orderListDialog'
import warehouseDialog from '@/components/basicinfo/basic/warehouse/listDialog'
import empDialog from '@/components/sales/business/empDialog'
import unitDialog from '@/components/basicinfo/basic/logistics/listDialog'
import invoiceSelect from '@/components/basedoc/invoice/select'
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    // saDialog,
    empDialog,
    unitDialog,
    orderDialog,
    invoiceSelect,
    warehouseDialog,
    customer
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocNo: '',
        DocDate: '',
        // SaDocId: 0,
        BrandCode: '',
        CustomerId: '',
        CustomerName: '',
        CustomerType: 1,
        SaDocNo: '',
        InvoiceType: 1,
        NeedInvoice: false,
        InvoiceNo: '',
        InvoiceAmount: '',
        FreightMode: 0,
        Remark: '',
        ActualFreight: 0,
        NoTaxAmount: 0,
        TaxAmount: 0,
        ReceiptAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        ReceiptConditionId: null,
        ClerkName: '',
        ClerkId: 0,
        OrderNo: '',
        OrderId: 0,
        Status: 0,
        Goods: [],
        ShowTax: 0,
        OutStatus: 0,
        CompleteStatus: 0,
        ReceiptStatus: 0,
        InvoiceStatus: 0,
        WarehouseId: '',
        WarehouseName: '',
        Receipts: [],
        Goods: [],
        Phone: '',
        Person: ''
      },
      OrderType: true,
      canExa: false,
      readonly: false,
      noEdit: false,
      recList: [],
      tableData: [],
      accountList: [],
      settleList: [],
      recCon: [],
      recDel: [],
      cList: [],
      api: require('@/api/sale/saDoc').default,
      recApi: require('@/api/sy/RecCon').default,
      settleApi: require('@/api/sale/settle').default,
      accountApi: require('@/api/sale/account').default,
      billApi: require('@/api/sy/bill').default,
      account_api: require('@/api/goods/goods').default,
      addressApi: require('@/api/ba/address').default,
      rules: {
        // WarehouseId: [{ required: true, message: "仓库不能为空" }],
        InvoiceType: [{ required: true, message: '票据类型不能为空' }],
        // ClerkName: [{ required: true, message: "业务员不能为空" }],
        CustomerId: [{ required: true, message: '客户名称不能为空' }],
        InvoiceNo: [{ required: true, message: '发票号码不能为空' }],
        InvoiceAmount: [{ required: true, message: '发票金额不能为空' }]
      },
      addressList: []
    }
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime())
    let today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    if (!this.data.DocDate) {
      this.data.DocDate = today
    }
    this.settleApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.settleList = res.Data
    })
    this.accountApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.accountList = res.Data
    })
    this.recApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.recCon = res.Data
    })
  },
  mounted() {
    if (this.$route.query.OrderId) {
      this.$nextTick(() => {
        this.setOrder({
          OrderNo: this.$route.query.OrderNo,
          OrderId: this.$route.query.OrderId
        })
      })
    }
  },
  methods: {
    querySearchAsync(queryString, cb) {
      var addressList = this.addressList
      var results = queryString ? addressList.filter(this.createFilter(queryString)) : addressList
      // 调用 callback 返回建议列表的数据
      console.log(results)
      cb(results)
    },
    createFilter(queryString) {
      return shopList => {
        return shopList.Person.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },

    handleSelect(item) {
      this.data.Person = item.Person
      this.data.Phone = item.Phone
    },
    setSupplier(data) {
      this.data.CustomerId = data.TradeUnitId
      this.data.CustomerName = data.TradeUnitName
      this.data.CustomerType = data.TradeUnitType
      if (data.EmpId == 0) {
        this.data.ClerkId = 1054
        this.data.ClerkName = '公司'
      } else {
        this.data.ClerkId = data.EmpId
        this.data.ClerkName = data.EmpName
      }

      let newData = tableData.filter(x => {
        if (x.GoodsId > 0) {
          return x
        }
      })

      if (newData.length > 0 && this.data.CustomerId > 0) {
        this.$confirm('是否更新商品报价', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var ids = newData.map(x => x.GoodsId)
          console.log(ids)
          if (ids.length > 0) {
            //获取所有商品报价
            this.api.GoodsOfferList({ CustomerId: this.data.CustomerId, GoodsIds: ids }).then(res => {
              if (res.Data.length > 0) {
                res.Data.forEach(x => {
                  tableData.forEach((g, index, tables) => {
                    if (g.GoodsId == x.GoodsId) {
                      tables[index].T = tables[index].T == 0 ? 0 : 1
                      tables[index].Offer = x.GoodsOffer
                      tables[index].Price = x.GoodsOffer

                      // 更新金额
                      let dis = tables[index].Discount > 0 ? Number(tables[index].Discount) : 100
                      let rate = tables[index].TaxRate ? Number(tables[index].TaxRate) : 0
                      let qua = tables[index].Quantity1 ? Number(tables[index].Quantity1) : 0
                      tables[index].Price = dis ? (tables[index].Offer * (dis / 100) * (1 + rate / 100)).toFixed(4) : (tables[index].Offer * (1 + rate / 100)).toFixed(4)
                      tables[index].Amount = ((tables[index].Price * qua * 100) / 100).toFixed(2)
                      tables[index].NoTaxAmount = (tables[index].Offer * (dis / 100) * tables[index].Quantity1).toFixed(2)
                      this.getList(this.$refs.dialogList.tableData)
                    }
                  })
                })
              }
            })
          }
        })
      }
      this.addressApi.list({ TradeUnitId: data.TradeUnitId }).then(res => {
        if (res.Code == 0) {
          this.addressList = res.Data
          if (res.Count > 0) {
            this.data.Person = res.Data[0].Person
            this.data.Phone = res.Data[0].Phone
          }
        } else {
          this.$message.warning(res.Msg)
        }
      })
      let tableData = this.$refs.dialogList.tableData
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null
    },
    setWarehouse(e) {
      this.data.WarehouseId = e.WarehouseId
      this.data.WarehouseName = e.WarehouseName

      this.$refs.dialogList.ChangeWarehouseId(e.WarehouseId)
    },
    openWarehouse(e) {
      this.$refs.warehouseDialog.open().then(that => {
        that.getData({})
        that.getTree()
      })
    },
    invoiceChange(e, data, type) {
      console.log('e==========', e)
      this.data.NeedInvoice = data.NeedInvoice
      if (!data.NeedInvoice) {
        this.data.InvoiceNo = ''
        this.data.InvoiceAmount = ''
      }
      this.$nextTick(() => {
        this.$refs.dialogList.setDefTaxRate(data.DefTaxRate, type)
      })
    },
    addOrder() {
      this.$refs.orderDialog.open().then(that => {
        that.getData()
      })
    },
    setOrder(e) {
      this.data.OrderNo = e.OrderNo
      this.data.OrderId = e.OrderId
      this.data.CustomerName = e.CustomerName
      this.data.CustomerId = e.CustomerId
      this.data.Person = e.FirstPerson
      this.data.Phone = e.Phone
      this.$refs.dialogList.getDataFromOrder(e.OrderId)
    },
    addUnit(e) {
      this.$refs.unitDialog.open().then(that => {
        that.getData({})
      })
    },
    setUnit(e) {
      this.data.CustomerId = e.Id
      this.data.CustomerName = e.Name
      this.data.CustomerType = e.TradeUnitType
      if (e.EmpId == 0) {
        this.data.ClerkId = 1054
        this.data.ClerkName = '公司'
      } else {
        this.data.ClerkId = e.EmpId
        this.data.ClerkName = e.EmpName
      }
      this.api.GetLast({ cid: e.Id }).then(res => {
        if (res.Code == 0 && res.Data) {
          this.data = res.Data
          // if(e.WarehouseId>0){
          //   this.setWarehouse(e)
          // }
          if (res.Data.Pays && res.Data.Pays.length > 0) {
            this.recList = JSON.parse(JSON.stringify(res.Data.Pays))
          }
          if (res.Data.Goods && res.Data.Goods.length > 0) {
            this.$refs.dialogList.tableData = JSON.parse(JSON.stringify(res.Data.Goods))
          }
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    getList(list) {
      this.tableData = list
      let Amount = 0
      let TaxAmount = 0
      let ReceiptAmount = this.data.ReceiptAmount || 0
      let ActualFreight = this.data.ActualFreight || 0
      list.forEach(item => {
        if (item.T != 2) {
          Amount += Number(Number(item.Amount).toFixed(2))
          TaxAmount += Number(Number(item.TaxAmount).toFixed(2))
        }
      })
      this.data.Amount = Number(Amount).toFixed(2)
      this.data.TaxAmount = TaxAmount
      this.data.NoTaxAmount = Amount - TaxAmount
      this.data.RemainAmount = Number(ActualFreight + Amount - ReceiptAmount).toFixed(2)
    },
    saChange(index) {
      //
      if (this.recList[index].T !== 0) {
        this.recList[index].T = 1
      }
    },
    recChange(index, type) {
      let ReceiptAmount = 0
      let ActualFreight = this.data.ActualFreight || 0
      let Amount = this.data.Amount
      if (!Amount) {
        Amount = 0
      }
      this.recList.forEach(item => {
        if (item.ReceiptAmount) {
          ReceiptAmount += Number(item.ReceiptAmount)
        }
      })
      if (type != 'del') {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 1
        }
      }
      this.data.ReceiptAmount = Number(ReceiptAmount)
      this.data.RemainAmount = ActualFreight + this.data.Amount - this.data.ReceiptAmount
    },
    add() {
      this.recList.push({
        T: 0,
        DocId: this.data.DocId,
        DocReceiptId: 0,
        OrderReceiptId: 0,
        OrderId: this.data.OrderId,
        SettleId: null,
        AccountId: null,
        ReceiptAmount: 0,
        AddTime: this.data.DocDate
      })
    },
    del(index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 2
          this.recDel.push(this.recList[index])
        }
        this.recList.splice(index, 1)
        this.recChange(index, 'del')
      })
    },
    addEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData({ Status: 1 })
      })
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    examine() {
      if (!this.onBeforeSave()) return false
      console.log(this.onBeforeSave())
      if (!this.data.WarehouseId) {
        this.$message.error('请填写仓库')
        return
      }
      this.$confirm('确认通过吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if (res.Code == 0) {
            this.$message.success('审核成功')
            this.readonly = true
            this.close()
            this.$emit('close-saved')
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm('确认弃审吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.cancelExamine(this.data.DocId).then(res => {
          if (res.Code == 0) {
            this.$message.success('弃审成功')
            this.readonly = false
            this.close()
            this.$emit('close-saved')
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened(data) {
      this.OrderType = true
      this.canExa = false
      this.cList = JSON.parse(sessionStorage.getItem('cList'))
      this.recList = []
      this.$refs.dialogList.tableData = [
        {
          T: 0,
          OrderGoodsId: 0,
          OrderId: 0,
          BarCode: '',
          GoodsName: '',
          GoodsId: '',
          Model: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 0,
          Quantity1: 0,
          Quantity2: 0,
          BatchNo: '',
          Offer: 0,
          Discount: 100,
          Price: 0,
          CostPrice: 0,
          CostPriceState: false,
          ExistQuantity: 0,
          AvailableQuantity: 0,
          TaxRate: 0,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: 0,
          GrossProfit: 0,
          Remark: '',
          Thumbnail: '',
          OutQuantity: 0,
          AddTime: '',
          DAccount: [],
          UnitId: '',
          UnitId1: '',
          UnitId2: ''
        }
      ]
      this.$refs.dialogList.tableDel = []
      // var user = this.$store.state.user;
      // if (user) {
      //   this.data.ClerkId = user.empId;
      //   this.data.ClerkName = user.name;
      // }

      this.billApi.getDefaultSerialNo('销货单').then(res => {
        if (res.Code == 0 && res.Data) {
          this.data.DocNo = res.Data
        } else if (res.Code == 0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
      console.log('data', data)
      if (data != null) {
        this.$refs.dialogList.tableData = data.Goods
        this.recList = this.data.Receipts
        if (data.ClerkId == 0) {
          this.data.ClerkId = 1054
          this.data.ClerkName = '公司'
        }
      } else {
        this.data.ClerkId = 1054
        this.data.ClerkName = '公司'
      }
      this.readonly = true
      this.$nextTick(() => {
        this.readonly = false
      })
    },
    setT(num) {
      this.T = num
    },
    onEditOpened(row) {
      if (sessionStorage.getItem('check') === '1') {
        this.canExa = true
        this.readonly = true
        this.OrderType = false
        sessionStorage.removeItem('check')
      } else {
        this.canExa = false
        this.readonly = false
        this.OrderType = false
      }
      this.recList = []
      this.$refs.dialogList.tableData = []
      this.$refs.dialogList.tableDel = []

      this.$refs.dialogList.getData(row)
      this.cList = JSON.parse(sessionStorage.getItem('cList'))
      if (row.ReceiptConditionId == 0) {
        this.data.ReceiptConditionId = null
      }
      this.recList = this.data.Receipts
      this.addressApi.list({ TradeUnitId: this.data.CustomerId }).then(res => {
        if (res.Code == 0) {
          this.addressList = res.Data
        } else {
          this.$message.warning(res.Msg)
        }
      })
    },
    onBeforeSave() {
      let tableData = this.$refs.dialogList.tableData
      console.log('tableData', tableData)
      let tableDel = this.$refs.dialogList.tableDel
      let tb = []
      if (tableData.length == 0 || !tableData.some(v => v.GoodsId)) {
        this.$message.error('请填写商品列表')
        return false
      }
      for (var i = 0; i < tableData.length; i++) {
        if (tableData[i].GoodsId) {
          if (!tableData[i].WarehouseId) {
            tableData[i].WarehouseId = 0
            this.$message.error('请选择仓库')
            return false
          }
          if (!tableData[i].GoodsName) {
            this.$message.error('请选择商品')
            return false
          }
          if (!(tableData[i].Quantity > 0)) {
            this.$message.error('请填写正确数量')
            return false
          }
          if (!tableData[i].Discount) {
            tableData[i].Discount = 100
          }
          if (tableData[i].T === 0 || tableData[i].T === 1) {
            this.$delete(tableData[i], 'unit')
            this.$delete(tableData[i], 'Rate1')
            this.$delete(tableData[i], 'Rate2')
            tb.push(tableData[i])
          }
        }
      }
      console.log('tb', tb)
      this.data.Goods = tb.concat(tableDel)
      this.data.Goods = this.data.Goods.map(x => {
        return this.$commonJs.obj.removeNullKey(x)
      })
      // if(!this.data.RemainAmount&&this.data.RemainAmount!==0||this.recList.length==0) {
      //   this.$message.error("请填写收款信息");
      //   return false
      // }
      if (this.data.ReceiptConditionId === null) {
        this.data.ReceiptConditionId = 0
      }
      let rec = []
      this.recList.forEach(item => {
        if (item.T || item.T === 0) {
          rec.push(item)
        }
      })
      for (var i = 0; i < rec.length; i++) {
        if (!rec[i].SettleId) {
          this.$message.error('请选择结算方式')
          return false
        }
        if (!rec[i].AccountId) {
          this.$message.error('请选择收款账号')
          return false
        }
        if (!rec[i].ReceiptAmount) {
          this.$message.error('请填写正确收款金额')
          return false
        }
      }
      this.data.Receipts = rec.concat(this.recDel)
      this.data.Receipts.forEach(item => {
        if (!item.SettleId) {
          item.SettleId = 0
        }
        if (!item.AccountId) {
          item.AccountId = 0
        }
      })
      console.log('data', this.data)

      return true
    }
  }
}
</script>
<style lang="scss">
.is-disabled {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
  }
}
</style>
